<template>
  <div
    :class="{
      'opacity-50 pointer-events-none': disabled,
    }"
  >
    <label
      v-if="label !== false"
      for="price"
      class="block text-sm font-medium leading-6"
    >
      {{ label ?? "Price" }}
    </label>
    <div
      class="relative rounded-md shadow-sm"
      :class="{ 'mt-2': label !== false }"
    >
      <div
        class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
      >
        <span class="text-neutral-500 sm:text-sm">
          {{ currencyMap[currency] }}
        </span>
      </div>
      <input
        type="number"
        name="price"
        class="block w-full dark:bg-neutral-800 transition-colors border border-neutral-500 focus:border-nami-comi-blue rounded-md py-1.5 pl-7 pr-12 placeholder:text-neutral-400 sm:text-sm sm:leading-6"
        placeholder="5"
        aria-describedby="price-currency"
        :value="String(modelValue)"
        :min
        :max
        @input="
          (e) => {
            const value = Math.max(
              min ?? -Infinity,
              Math.min(
                max ?? Infinity,
                Number((e.target as HTMLInputElement).value),
              ),
            ).round(2);
            emit('update:modelValue', value);
          }
        "
      />
      <div
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
      >
        <span class="text-neutral-500 sm:text-sm" id="price-currency">{{
          currency
        }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  modelValue: number;
  currency: string;
  label?: string | boolean;
  disabled?: boolean;
  min?: number;
  max?: number;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", v: number): void;
}>();

const currencyMap: { [key: string]: string } = {
  USD: "$",
};
</script>
